<template>
  <div
      :style="{'--dropdownMenuWidth':dropdownMenuWidth, '--dropdownMenuLeft': dropdownMenuLeft,'--borderColor': borderColor}">

    <van-dropdown-menu class="flex-1" ref="dropdownMenu">
      <van-dropdown-item ref="dropdownItem"  :disabled="disabled">
        <template #title>
          <div class="flex-1 text-14px" :class="ingredientTextClass">{{ ingredientText }}</div>
        </template>

        <template>
          <div class="dropdown-menu-custom">
            <div @click="onInput(item, index)" class="p-1 text-14px" v-for="(item,index) in options"
                :key="item.value"> {{ item.text }}
            </div>
          </div>
        </template>
      </van-dropdown-item>

    </van-dropdown-menu>
  </div>
</template>
<script>
import log from "@/util/log"
export default {
  name: "DropdownSelect",
  props: {
    disabled: {
      type:Boolean,
      default: false
    },
    placeHolder: {
      type:String,
      default: ""
    },
    value: [Number, String],
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      test: 0,
      dropdownMenuWidth: 0,
      dropdownMenuLeft: 0
    };
  },
  mounted() {
    log(this.showError);
    this.$nextTick(() => {
      const el = this.$refs.dropdownMenu.$el;
      const clientWidth = el.clientWidth;
      const offsetLeft = el.offsetLeft;
      this.dropdownMenuWidth = `${clientWidth}px`;
      this.dropdownMenuLeft = `${offsetLeft}px`;
      log(`dropdownMenu = ${clientWidth}`);
    });
  },
  methods: {
    onInput(item, optionIndex) {
      this.$refs.dropdownItem.toggle();
      log(item);
      this.$emit("input", item, optionIndex);
    }
  },
  computed: {
    ingredientText() {
      if (this.value === "") {
        return this.placeHolder;
      }
      return this.value;
    },
    ingredientTextClass() {
      if (this.value === "") {
        return "third-color";
      }
      return "";
    },
    borderColor() {
      if (this.showError) {
        return "red";
      } else {
        return "#E8E8E8";
      }
    }
  }
};
</script>


<style scoped lang="less">
::v-deep .van-dropdown-menu {
  border-radius: 8px;
  border: 1px solid var(--borderColor);

  .van-dropdown-menu__bar {
    background: transparent;
    box-shadow: none;
    height: 32px;
  }

  .van-dropdown-menu__title {
    flex: 1;
    font-size:14px;
  }

  .van-dropdown-menu__title::after {
    right: 20px;
  }

  .van-popup--top {
    width: var(--dropdownMenuWidth);
    left: var(--dropdownMenuLeft)
  }

  .van-overlay {
    background-color: transparent;
  }

  .van-cell__title {
    text-align: center;
  }
}

.dropdown-menu-custom {
  background: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 1px #E8E8E8 solid;
  border-left: 1px #E8E8E8 solid;
  border-right: 1px #E8E8E8 solid;
  padding: 10px 0;
  font-size:14px;

  box-shadow: 1px 1px 1px -1px rgba(0, 0, 0, 0.15);
}

</style>